export default __webpack_public_path__ + "static/media/Athena_sql.666d06d3.png";